import Auth from "./Auth";
import Filter from "./Filter";
import Local from "./Local";
import Helper from "./Helper";
import Dashboard from "./Dashboard";
import Chat from "./Chat";
import Theme from "./Theme";
import History from "./History";

class Reducers {
  static Auth = Auth;
  static Filter = Filter;
  static Local = Local;
  static Helper = Helper;
  static Dashboard = Dashboard;
  static Chat = Chat;
  static Theme = Theme;
  static History = History;
}

export default Reducers;
